import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownUserComponent } from './dropdown-user.component';
import { RouterModule } from '@angular/router';
import { ClickOutsiteModule } from '../../directives/click-outsite/click-outsite.module';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ClickOutsiteModule
  ],
  declarations: [ DropdownUserComponent ],
  exports: [ DropdownUserComponent ]
})
export class DropdownUserModule { }
